import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=2282a2ef&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=2282a2ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282a2ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2282a2ef')) {
      api.createRecord('2282a2ef', component.options)
    } else {
      api.reload('2282a2ef', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=2282a2ef&scoped=true&", function () {
      api.rerender('2282a2ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PdljHn5WMR91/JS/comp/DocBox.vue"
export default component.exports